<template>
  <div class="promotion-wrap">
    <div class="header">
      <div class="swipe">
        <img src="../../assets/image/Zuzuche/swipe_1.png"/>
      </div>
      <img class="header_top_img top_img" src="../../assets/image/Zuzuche/banner_1.png"/>
      <img class="header_top_img " src="../../assets/image/Zuzuche/banner_2.png"/>
      <img class="mask" src="../../assets/image/Zuzuche/swipe_mask.png"/>
      <img class="bottom_img" src="../../assets/image/Zuzuche/banner_3.jpg"/>
    </div>
    <div class="applyPart">
      <div class="item item-city">
        <input type="text" v-model="city" placeholder="所在城市" maxlength="18" @blur="blur"/>
      </div>
      <div class="item item-carType">
        <input type="text" placeholder="请选择车型" v-model="carModel" readonly>
        <select v-model="carModel" @click="carChange">
          <option v-for="carname in carModelListNew">{{carname}}</option>
        </select>
        <img src="../../assets/image/Zuzuche_Pro/arrow.png">
      </div>
      <div class="item item-mobile">
        <input type="tel" v-model="mobile" placeholder="请输入手机号" maxlength="11" @blur="blur"/>
      </div>
      <div class="item item-check">
        <input type="number" v-model="vCode" placeholder="请输入验证码" maxlength="6" @blur="blur" @input="vCodeMaxLength"/>
        <button ref="code" v-html="vCodeStr" @click="getCode"></button>
      </div>
      <button @click="submit">提交申请</button>
    </div>
    <img class="page-img-item2" src="../../assets/image/Zuzuche/banner_4.jpg"/>
    <img class="page-img-item2" src="../../assets/image/Zuzuche/banner_5.jpg" v-if="isDetailsFlag" @click="isDetailsFlag =!isDetailsFlag"/>
    <img class="page-img-item2" src="../../assets/image/Zuzuche/banner_6.jpg" v-if="!isDetailsFlag" @click="isDetailsFlag =!isDetailsFlag"/>
    <img src="../../assets/image/Zuzuche/banner_7.jpg"/>
  </div>
</template>

<script>
  import common from '../../utils/common'
  import constants from '../../utils/constants'
  import qs from 'qs'

  export default {
    name: "Zuzuche",
    data() {
      return {
        isDetailsFlag: true,
        city: null,
        carModel: null,
        mobile: null,
        vCode: null,
        carModelListNew: ['Model 3', 'Model S', 'Model X'],
        vCodeStr: '获取验证码',
        leadsChannel: '租租车',
        sourceType: '23',
        firstOpen: true,
       }
    },
    mounted() {
      window.scrollTo(0, 0)
      const that = this
      that.$nextTick(function () {
        if(!common.isEmpty(common.getUrlKey('type'))){
          that.leadsChannel = that.leadsChannel + '-' +common.getUrlKey('type')
          constants.ZZC_SHAREINFO.link = constants.ZZC_SHAREINFO.link + '?type=' + common.getUrlKey('type')
        }
        /* 记录促销页面打开时间 */
        that.$axios.post('/marketing/initInfoInsert', qs.stringify({'leadsChannel': that.leadsChannel})).then(function (res) {
          return
        }).catch(function (error) {
          return
        })
        common.wxShare(that, constants.ZZC_SHAREINFO)
      });
    },
    methods: {
      blur() {
        common.blurPageScroll()
      },

      carChange(){
        if(this.firstOpen) {
          this.carModel = this.carModelListNew[0]
          this.firstOpen = false
        }
      },

      // vue input type 为number时用maxlength无效
      //  此方法限制验证码输入位数
      vCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
      },

      // 获取验证码
      getCode(e) {
        common.getVCodeMarketingCode(this, e)
      },

      submit() {
        const that = this
        that.city = common.trimAll(that.city)
        that.mobile = common.trimAll(that.mobile)
        that.vCode = common.trimAll(that.vCode)
        if (common.isEmpty(that.city)) {
          common.tipToast("请输入所在城市")
          return
        }
        if (common.isEmpty(that.carModel)) {
          common.tipToast("请选择车型")
          return
        }
        if (common.isEmpty(that.mobile)) {
          common.tipToast("请输入手机号码")
          return
        }
        if (!common.checkMobile(that.mobile)) {
          common.tipToast("手机号码格式不正确")
          return
        }
        if (common.isEmpty(that.vCode)) {
          common.tipToast("请输入手机号验证码")
          return
        }

        that.$axios.post('/marketing/createOrder', qs.stringify({
          'city': that.city,
          'carModel': that.carModel,
          'mobile': that.mobile,
          'code': that.vCode,
          'leadsChannel': that.leadsChannel,
          'sourceType': that.sourceType
        })).then(function (res) {
          clearInterval(common.VCodeObj.timer); // 清除js定时器
          that.city = null
          that.carModel = null
          that.mobile = null
          that.vCode = null
          that.vCodeStr = '获取验证码',
          common.VCodeObj.timeCount = 60
          common.VCodeObj.timer = null
          that.$refs.code.disabled = false
          if(!common.isEmpty(common.getUrlKey('type'))){
            common.redirect(that, 'success?type=' + common.getUrlKey('type'))
          }else {
            common.redirect(that, 'success')
          }
          return
        }).catch(function (err) {
          that.vCode = null
          common.tipToast(err.data.msg)
          return
        })
      }
    },
  }
</script>

<style scoped>
  .promotion-wrap {
    margin: 0 auto;
    max-width: 7.50rem;
    min-width: 3.20rem;
    position: relative;
    font-size: 0;
    width: 100%;
    text-align: center;
    background-color: #000;
  }

  .promotion-wrap > .header {
    position: relative;
    padding-bottom: 1.43rem;
    font-size: 0;
  }
  .header > .swipe {
    height: 5.96rem;
    color: #fff;
    font-size: 30px;
    text-align: center;
  }

  .header > .swipe  img {
    width: 100%;
    height: 100%;
  }

  .header > .mask {
    position: absolute;
    left: 0;
    bottom: 1.43rem;
    width: 7.5rem;
    pointer-events: none;
    z-index: 2;
  }

  .header > .header_top_img {
    position: absolute;
    top: 0.4rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 4.97rem;
    height: 1.06rem;
  }

  .header > .top_img {
    width: 7.5rem;
    top: 0;
  }

  .header > .bottom_img {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 0rem;
    width: 6.70rem;
    height: 2.27rem;
    z-index: 3;
  }


  .promotion-wrap > img {
    width: 100%
  }

  .promotion-wrap > .page-img-item2 {
    width: 6.70rem;
    margin: 0 auto;
    margin-top: 0.38rem;
  }

  .promotion-wrap > img:last-child {
    margin: 0 auto;
    padding: 0.66rem 0 0.75rem 0;
    width: 6.70rem
  }

  .applyPart {
    margin: 0.38rem auto;
    margin-bottom: 0;
    padding-top: 0.23rem;
    padding-bottom: 0.27rem;
    width: 6.70rem;
    background-image: url("../../assets/image/Zuzuche_Pro/zzc_2.png");
    background-size: cover;
    background-repeat: no-repeat;
  }


  .applyPart > button {
    margin-top: 0.34rem;
    width: 5.98rem;
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.32rem;
    color: #fff;
    border-width: 0;
    background-color: #a71023;
    outline: none;
  }

  .item:first-child {
    margin-top: 0;
  }
  .item {
    border-bottom: 0.01rem solid rgba(227,227,227,0.27);
    position: relative;
    margin: 0 auto;
    margin-top: 0.27rem;
    width: 5.98rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .item > input {
    width: 100%;
    height: 0.77rem;
    line-height: 0.36rem;
    border-width: 0;
    outline: 0;
    font-size: 0.30rem;
    color: #fff;
    background-color: rgba(255, 255, 255, 0);
  }

  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #b2b1b1;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #b2b1b1;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #b2b1b1;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #b2b1b1;
  }

  .item-carType {
    height: 0.77rem;
  }

  .item-carType > input {
    position: absolute;
    height: 0.75rem;
    pointer-events: none;
    z-index: 2;
  }

  .item > select {
    display: block;
    width: 100%;
    height: 0.75rem;
    font-size: 0.32rem;
    background-color: rgba(255, 255, 255, 0);
    color: #b2b1b1;
    border-width: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: 0;
    opacity: 0;
  }

  select > option {
    background-color: #fff;
  }

  .item > img {
    position: absolute;
    right: 0.24rem;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 0.28rem;
    height: 0.15rem;
    z-index: 5;
  }
  .item-check {
    margin: 0 auto;
    padding-top: 0.27rem;
  }
  .item-check > button {
    position: absolute;
    border:0.02rem transparent solid;
    border-color: #a71023;
    width: 1.55rem;
    height: 0.62rem;
    text-align: center;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    font-size: 0.26rem;
    font-weight: 500;
    color: #a71023;
    outline: none;
    background-color: rgba(255, 255, 255, 0);
  }


</style>



// WEBPACK FOOTER //
// src/components/Promotion/Zuzuche.vue